import { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import ActivitiesHeroSection from "./activities section/ActivitiesHeroSection";
import ActivitiesCountryCardsSection from "./activities section/ActivitiesCountryCardsSection";

const ActivitiesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <ActivitiesHeroSection />

      {/* Country Cards Section */}
      <ActivitiesCountryCardsSection />
    </div>
  );
};

export default ActivitiesPage;
